import styles from './inputSearch.module.scss'
import React, {
  ChangeEventHandler,
  FocusEventHandler,
  KeyboardEventHandler,
  useState,
  useEffect,
} from 'react'
import { USBIconSearch } from '@usb-shield/react-icons'
import { useTranslation } from 'react-i18next';
import inputTranslations from '../../../i18n'
import { useCookies } from 'react-cookie'

const SEARCH_INPUT_LABEL = 'search input'

export const InputSearch = ({
  inputID,
  inputName,
  inputValue,
  handleSearchChange,
  handleSearchFocus,
  handleSearchKeyDown,
  handleSearchKeyUp,
  inputTitle,
  customClass,
}: {
  inputID: string
  inputName: string
  inputValue?: string
  handleSearchChange?: ChangeEventHandler<HTMLInputElement>
  handleSearchFocus?: FocusEventHandler<HTMLInputElement>
  handleSearchKeyDown?: KeyboardEventHandler<HTMLInputElement>
  handleSearchKeyUp?: KeyboardEventHandler<HTMLInputElement>
  inputTitle?: string
  customClass?: string
}) => {
  const { t } = useTranslation()
  const [locale, setLocale] = useState<string>(process.env.DEFAULT_LOCALE)
  const [cookies] = useCookies(['locale'])
  const SEARCH_PLACEHOLDER_TEXT = t('homeSearchPlaceholder', {inputTranslations, lng: locale})

  useEffect(() => {
    const localeFromCookies = cookies.locale || process.env.DEFAULT_LOCALE
    setLocale(localeFromCookies)
  }, [])

  return (
    <div className={styles.searchContainer + ' ' + customClass}>
      <label className={styles._label} htmlFor={inputID} aria-label={SEARCH_INPUT_LABEL}>
        <USBIconSearch
          size="20"
          addClasses={styles.usbSearch_label_icon}
          colorVariant="grey80"
        />
      </label>
      <input
        type="search"
        className={styles.usbSearch_input}
        id={inputID}
        name={inputName}
        value={inputValue}
        placeholder={SEARCH_PLACEHOLDER_TEXT}
        onChange={handleSearchChange}
        onFocus={handleSearchFocus}
        onKeyDown={handleSearchKeyDown}
        onKeyUp={handleSearchKeyUp}
        title={inputTitle}
        autoComplete="off"
      />
    </div>
  )
}
